/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Session_DetailsInputs */

const en_audit_session_details = /** @type {(inputs: Audit_Session_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit Session Details`)
};

const es_audit_session_details = /** @type {(inputs: Audit_Session_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de Sesion de Auditoria`)
};

/**
* | output |
* | --- |
* | "Audit Session Details" |
*
* @param {Audit_Session_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_session_details = /** @type {((inputs?: Audit_Session_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Session_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_session_details(inputs)
	return es_audit_session_details(inputs)
});